import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { applicationsApi } from '@api/applications/applicationsApi';
export const useApplications = (): UseQueryResult<any> =>
  useQuery(['applications'], () => applicationsApi.getAll() || null);
